<template>
  <section>
    <div class="custom-file-input logo">
      <input
        class="upload-input"
        type="file"
        accept="video/mp4"
        ref="inputFile"
        @change="onFileChange"
      />
      <img :src="videoPreview" alt="" class="upload-img" />
      <div id="fileDrag">
        Choose a file or drop one here
      </div>
    </div>
  </section>
</template>

<script>
import {getMetadata, getThumbnails} from 'video-metadata-thumbnails';
import Modal from '../helpers/Modal';

export default {
  props: {
    video: {
      default: null,
      type: Object,
    },
    displayLabel: {
      default: true,
      type: Boolean,
    },
    handleFileChange: {
      default: null,
      type: Function,
    },
  },
  computed: {
    videoPreview: function() {
      if (this.newVideoPreview) {
        return this.newVideoPreview;
      }
      if (this.video) {
        return `${process.env.VUE_APP_CDN_URL}${this.video.location}`;
      }
      return '';
    },
  },
  watch: {},
  data() {
    return {
      uploadFile: {},
      metadata: {},
      newVideoPreview: null,
      modalVisible: false,
    };
  },
  methods: {
    onAgreedClicked() {
      this.modalVisible = false;
    },
    onVideoUploadRequirementsClicked() {
      this.modalVisible = true;
    },
    onFileChange() {
      this.uploadFile = this.$refs.inputFile.files[0];
      this.getVideoPreview();
      if (this.handleFileChange) {
        this.handleFileChange(this.uploadFile);
      }
    },
    async getVideoPreview() {
      if (this.uploadFile) {
        var videoUpload = this;
        const thumbnails = await getThumbnails(this.uploadFile, {
          interval: 1,
          start: 0,
          end: 1,
          quality: 0.6,
        }).then(function(thumbnails) {
          videoUpload.newVideoPreview = URL.createObjectURL(thumbnails[0].blob);
        });
        const metadata = await getMetadata(this.uploadFile).then(function(
          metadata
        ) {
          videoUpload.metadata = metadata;
        });
      }
    },
    clearVideo() {
      console.log('Clearing video selection');
      this.$refs.inputFile.value = '';
      this.uploadFile = {};
      this.newVideoPreview = null;
      this.metadata = {};
    },
  },
};
</script>
